// ** Route Keys - Static keys for internationalized routing
export const ROUTE_KEYS = {
  // Feed/Tipster Area
  FEED: 'route_link_feed',
  
  // Coupon related
  COUPON_GENERATOR: 'route_link_coupon_generator',
  ADD_CUSTOM_BET: 'route_link_add_custom_bet',
  ADD_BET: 'route_link_add_bet',
  ADD_BET_WITH_PARAMS: 'route_link_add_bet_with_params',
  
  // Tipsters
  TIPSTERS: 'route_link_tipsters',
  TIPSTER_PROFILE: 'route_link_tipster_profile',
  
  // Tournament
  TOURNAMENT: 'route_link_tournament',
  TOURNAMENT_DETAILS: 'route_link_tournament_details',
  
  // Auth
  LOGIN: 'route_link_login',
  FORGOT_PASSWORD: 'route_link_forgot_password',
  RESET_PASSWORD: 'route_link_reset_password',
  REGISTER: 'route_link_register',
  REGISTER_THANKS: 'route_link_register_thanks',
  REGISTER_CONFIRM: 'route_link_register_confirm',
  
  // Other
  RULES: 'route_link_rules',
  RULES_TIPSTER: 'route_link_rules_tipster',
  RULES_PAID_BETS: 'route_link_rules_paid_bets',

  // Settings
  ACCOUNT_SETTINGS: 'route_link_account_settings',
  TIPSTER_SETTINGS: 'route_link_tipster_settings',
  USER_CHECKOUT: 'route_link_user_checkout',
  CHECKOUT_WITH_ID: 'route_link_checkout_with_id'
}

// ** Supported languages
export const SUPPORTED_LANGUAGES = ['en', 'pl', 'sr', 'es', 'pt']

// ** Route mapping for different languages - Optimized for 5 languages
export const ROUTE_MAPPING = {
  en: {
    [ROUTE_KEYS.FEED]: '/tipster-area',
    [ROUTE_KEYS.COUPON_GENERATOR]: '/coupon-generator',
    [ROUTE_KEYS.ADD_CUSTOM_BET]: '/add-custom-bet',
    [ROUTE_KEYS.ADD_BET]: '/add-bet',
    [ROUTE_KEYS.ADD_BET_WITH_PARAMS]: '/add-bet/:sport/:url/:lid?',
    [ROUTE_KEYS.TIPSTERS]: '/tipsters',
    [ROUTE_KEYS.TIPSTER_PROFILE]: '/tipster/:id',
    [ROUTE_KEYS.TOURNAMENT]: '/championship-tipsters',
    [ROUTE_KEYS.TOURNAMENT_DETAILS]: '/tournaments/:id',
    [ROUTE_KEYS.LOGIN]: '/login',
    [ROUTE_KEYS.FORGOT_PASSWORD]: '/forgot-password',
    [ROUTE_KEYS.RESET_PASSWORD]: '/reset-password/:token?',
    [ROUTE_KEYS.REGISTER]: '/register',
    [ROUTE_KEYS.REGISTER_THANKS]: '/thanks-for-registering',
    [ROUTE_KEYS.REGISTER_CONFIRM]: '/register-confirm/:token',
    [ROUTE_KEYS.RULES]: '/rules',
    [ROUTE_KEYS.RULES_TIPSTER]: '/rules/paid-tipster',
    [ROUTE_KEYS.RULES_PAID_BETS]: '/rules/paid-bets',
    [ROUTE_KEYS.ACCOUNT_SETTINGS]: '/account-settings',
    [ROUTE_KEYS.TIPSTER_SETTINGS]: '/tipster-settings',
    [ROUTE_KEYS.USER_CHECKOUT]: '/checkout',
    [ROUTE_KEYS.CHECKOUT_WITH_ID]: '/checkout/:id'
  },
  pl: {
    [ROUTE_KEYS.FEED]: '/strefa-typerow',
    [ROUTE_KEYS.COUPON_GENERATOR]: '/generator-kuponow',
    [ROUTE_KEYS.ADD_CUSTOM_BET]: '/dodaj-wlasny-zaklad',
    [ROUTE_KEYS.ADD_BET]: '/dodaj-nowy-zaklad',
    [ROUTE_KEYS.ADD_BET_WITH_PARAMS]: '/dodaj-nowy-zaklad/:sport/:url/:lid?',
    [ROUTE_KEYS.TIPSTERS]: '/typerzy',
    [ROUTE_KEYS.TIPSTER_PROFILE]: '/typer/:id',
    [ROUTE_KEYS.TOURNAMENT]: '/fame29',
    [ROUTE_KEYS.TOURNAMENT_DETAILS]: '/turnieje/:id',
    [ROUTE_KEYS.LOGIN]: '/logowanie',
    [ROUTE_KEYS.FORGOT_PASSWORD]: '/zapomnialem-hasla',
    [ROUTE_KEYS.RESET_PASSWORD]: '/resetuj-haslo/:token?',
    [ROUTE_KEYS.REGISTER]: '/rejestracja',
    [ROUTE_KEYS.REGISTER_THANKS]: '/podziekowanie-za-rejestracje',
    [ROUTE_KEYS.REGISTER_CONFIRM]: '/potwierdz-konto/:token',
    [ROUTE_KEYS.RULES]: '/regulamin',
    [ROUTE_KEYS.RULES_TIPSTER]: '/regulamin/platny-typer',
    [ROUTE_KEYS.RULES_PAID_BETS]: '/regulamin/platne-typy',
    [ROUTE_KEYS.ACCOUNT_SETTINGS]: '/ustawienia-konta',
    [ROUTE_KEYS.TIPSTER_SETTINGS]: '/ustawienia-typera',
    [ROUTE_KEYS.USER_CHECKOUT]: '/koszyk',
    [ROUTE_KEYS.CHECKOUT_WITH_ID]: '/koszyk/:id'
  },
  sr: {
    [ROUTE_KEYS.FEED]: '/zona-igraca',
    [ROUTE_KEYS.COUPON_GENERATOR]: '/generator-kupona',
    [ROUTE_KEYS.ADD_CUSTOM_BET]: '/dodaj-vlastitu-opkladu',
    [ROUTE_KEYS.ADD_BET]: '/dodaj-novu-opkladu',
    [ROUTE_KEYS.ADD_BET_WITH_PARAMS]: '/dodaj-novu-opkladu/:sport/:url/:lid?',
    [ROUTE_KEYS.TIPSTERS]: '/igraci',
    [ROUTE_KEYS.TIPSTER_PROFILE]: '/igrac/:id',
    [ROUTE_KEYS.TOURNAMENT]: '/prvenstvo-igraca',
    [ROUTE_KEYS.TOURNAMENT_DETAILS]: '/turniri/:id',
    [ROUTE_KEYS.LOGIN]: '/prijava',
    [ROUTE_KEYS.FORGOT_PASSWORD]: '/zaboravio-sam-lozinku',
    [ROUTE_KEYS.RESET_PASSWORD]: '/resetuj-lozinku/:token?',
    [ROUTE_KEYS.REGISTER]: '/registracija',
    [ROUTE_KEYS.REGISTER_THANKS]: '/hvala-za-registraciju',
    [ROUTE_KEYS.REGISTER_CONFIRM]: '/potvrdi-nalog/:token',
    [ROUTE_KEYS.RULES]: '/pravila',
    [ROUTE_KEYS.RULES_TIPSTER]: '/pravila/paid-tipster',
    [ROUTE_KEYS.RULES_PAID_BETS]: '/pravila/paid-bets',
    [ROUTE_KEYS.ACCOUNT_SETTINGS]: '/podesavanja-naloga',
    [ROUTE_KEYS.TIPSTER_SETTINGS]: '/podesavanja-igraca',
    [ROUTE_KEYS.USER_CHECKOUT]: '/checkout',
    [ROUTE_KEYS.CHECKOUT_WITH_ID]: '/checkout/:id'
  },
  es: {
    [ROUTE_KEYS.FEED]: '/zona-tipsters',
    [ROUTE_KEYS.COUPON_GENERATOR]: '/generador-cupones',
    [ROUTE_KEYS.ADD_CUSTOM_BET]: '/agregar-apuesta-personalizada',
    [ROUTE_KEYS.ADD_BET]: '/agregar-apuesta',
    [ROUTE_KEYS.ADD_BET_WITH_PARAMS]: '/agregar-apuesta/:sport/:url/:lid?',
    [ROUTE_KEYS.TIPSTERS]: '/tipsters',
    [ROUTE_KEYS.TIPSTER_PROFILE]: '/tipster/:id',
    [ROUTE_KEYS.TOURNAMENT]: '/campeonato-tipsters',
    [ROUTE_KEYS.TOURNAMENT_DETAILS]: '/torneos/:id',
    [ROUTE_KEYS.LOGIN]: '/iniciar-sesion',
    [ROUTE_KEYS.FORGOT_PASSWORD]: '/olvide-contrasena',
    [ROUTE_KEYS.RESET_PASSWORD]: '/restablecer-contrasena/:token?',
    [ROUTE_KEYS.REGISTER]: '/registro',
    [ROUTE_KEYS.REGISTER_THANKS]: '/gracias-por-registrarse',
    [ROUTE_KEYS.REGISTER_CONFIRM]: '/confirmar-cuenta/:token',
    [ROUTE_KEYS.RULES]: '/reglamento',
    [ROUTE_KEYS.RULES_TIPSTER]: '/reglamento/paid-tipster',
    [ROUTE_KEYS.RULES_PAID_BETS]: '/reglamento/paid-bets',
    [ROUTE_KEYS.ACCOUNT_SETTINGS]: '/configuracion-cuenta',
    [ROUTE_KEYS.TIPSTER_SETTINGS]: '/configuracion-tipster',
    [ROUTE_KEYS.USER_CHECKOUT]: '/checkout',
    [ROUTE_KEYS.CHECKOUT_WITH_ID]: '/checkout/:id'
  },
  pt: {
    [ROUTE_KEYS.FEED]: '/area-tipsters',
    [ROUTE_KEYS.COUPON_GENERATOR]: '/gerador-apostas',
    [ROUTE_KEYS.ADD_CUSTOM_BET]: '/adicionar-aposta-personalizada',
    [ROUTE_KEYS.ADD_BET]: '/adicionar-aposta',
    [ROUTE_KEYS.ADD_BET_WITH_PARAMS]: '/adicionar-aposta/:sport/:url/:lid?',
    [ROUTE_KEYS.TIPSTERS]: '/tipsters',
    [ROUTE_KEYS.TIPSTER_PROFILE]: '/tipster/:id',
    [ROUTE_KEYS.TOURNAMENT]: '/campeonato-tipsters',
    [ROUTE_KEYS.TOURNAMENT_DETAILS]: '/torneios/:id',
    [ROUTE_KEYS.LOGIN]: '/entrar',
    [ROUTE_KEYS.FORGOT_PASSWORD]: '/esqueci-senha',
    [ROUTE_KEYS.RESET_PASSWORD]: '/redefinir-senha/:token?',
    [ROUTE_KEYS.REGISTER]: '/registro',
    [ROUTE_KEYS.REGISTER_THANKS]: '/obrigado-por-registrar',
    [ROUTE_KEYS.REGISTER_CONFIRM]: '/confirmar-conta/:token',
    [ROUTE_KEYS.RULES]: '/regulamento',
    [ROUTE_KEYS.RULES_TIPSTER]: '/regulamento/paid-tipster',
    [ROUTE_KEYS.RULES_PAID_BETS]: '/regulamento/paid-bets',
    [ROUTE_KEYS.ACCOUNT_SETTINGS]: '/configuracoes-conta',
    [ROUTE_KEYS.TIPSTER_SETTINGS]: '/configuracoes-tipster',
    [ROUTE_KEYS.USER_CHECKOUT]: '/checkout',
    [ROUTE_KEYS.CHECKOUT_WITH_ID]: '/checkout/:id'
  }
}

// ** Optimized helper function to get route path by key and language
export const getRoutePath = (key, language = 'en') => {
  // Check if language is supported, fallback to 'en'
  const supportedLang = SUPPORTED_LANGUAGES.includes(language) ? language : 'en'
  return ROUTE_MAPPING[supportedLang]?.[key] || ROUTE_MAPPING.en[key]
}

// ** Optimized helper function to get all routes for a specific language
export const getRoutesForLanguage = (language = 'en') => {
  const supportedLang = SUPPORTED_LANGUAGES.includes(language) ? language : 'en'
  return ROUTE_MAPPING[supportedLang] || ROUTE_MAPPING.en
}

// ** Performance optimization: Cache for frequently accessed routes
const routeCache = new Map()

export const getCachedRoutePath = (key, language = 'en') => {
  const cacheKey = `${key}_${language}`
  
  if (routeCache.has(cacheKey)) {
    return routeCache.get(cacheKey)
  }
  
  const path = getRoutePath(key, language)
  routeCache.set(cacheKey, path)
  return path
}
